import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sling as Hamburger } from 'hamburger-react';
import logo from '../../assets/img/MobilAssistance.svg';
import logo2 from '../../assets/img/MobilAssistance.png';
import '../../App.css'; // Mevcut stilleri kullan

/**
 * Modern Header Component - Mevcut tasarımı koruyarak
 * - SEO friendly (semantic HTML)
 * - Accessible (ARIA labels)
 * - Responsive design
 * - Dropdown menüler dahil
 */
const Header = () => {
  const [isOpen, setOpen] = useState(false);
  const [kurumsalisopen, setiskurumsalOpen] = useState(false);
  const [hizmetlerisopen, setishizmetlerOpen] = useState(false);
  const [onlineisopen, setisonlineOpen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const location = useLocation();
  const ref = useRef(null);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  // Close menu when location changes
  useEffect(() => {
    setOpen(false);
    setiskurumsalOpen(false);
    setishizmetlerOpen(false);
    setisonlineOpen(false);
  }, [location]);

  // Toggle body class when menu opens/closes
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isOpen]);

  const ToggleKurumsal = () => {
    setiskurumsalOpen(!kurumsalisopen);
    setishizmetlerOpen(false);
    setisonlineOpen(false);
  };

  const ToggleHizmetler = () => {
    setishizmetlerOpen(!hizmetlerisopen);
    setiskurumsalOpen(false);
    setisonlineOpen(false);
  };

  const ToggleOnline = () => {
    setisonlineOpen(!onlineisopen);
    setiskurumsalOpen(false);
    setishizmetlerOpen(false);
  };

  return (
    <>
      <header className="o-header" role="banner">
        {width > 850 ? (
          <div className="o-header__top">
            <div className="o-header__logo">
              <div className="c-animated-logo">
                <div className="main-logo-container">
                  <div className="signal-container">
                    <div className="signal-element"></div>
                    <div className="signal-element-2"></div>
                  </div>
                  <div className="bottom-container">
                    <div className="logo-top-wrapper">
                      <Link to="/" aria-label="Mobil Assistance Ana Sayfa">
                        <img className="LogoWidth" alt="Mobil Assistance" src={logo} />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="o-header__nav">
              <ul className="c-nav">
                <li className="c-nav__item">
                  <div className="c-nav__item--menu-trigger">
                    <div className="o-nav-icon-bayi">
                      <div>
                        <a
                          className="c-special-button c-special-button--bayi"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://bayi.mobilassistance.com/Bayi_/Giris"
                        >
                          BAYİ GİRİŞİ
                        </a>
                      </div>
                    </div>
                    <div className="o-nav-icon" onClick={() => setOpen(!isOpen)}>
                      <span>MENÜ</span>
                      <Hamburger toggled={isOpen} size={30} toggle={setOpen} />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        ) : (
          <>
            <div className="o-header__top">
              <div className="mobil">
                <Link to="/" aria-label="Mobil Assistance Ana Sayfa">
                  <img alt="Mobil Assistance" src={logo2} />
                </Link>
              </div>
              <div className="o-header__nav">
                <ul className="c-nav">
                  <li className="c-nav__item">
                    <div className="c-nav__item--menu-trigger">
                      <div className="o-nav-icon" onClick={() => setOpen(!isOpen)}>
                        <span>MENÜ</span>
                        <Hamburger toggled={isOpen} size={30} toggle={setOpen} />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="o-header__nav-mobile-bayi">
              <a
                className="c-special-button c-special-button--bayi c-special-button--mobile"
                target="_blank"
                rel="noopener noreferrer"
                href="https://bayi.mobilassistance.com/Bayi_/Giris"
              >
                BAYİ GİRİŞİ
              </a>
            </div>
          </>
        )}
      </header>
      
      <div ref={ref} className="c-nav__item--menu-trigger">
        <div className={`c-main-nav__container ${isOpen ? 'is-open' : ''}`}>
          <div className="o-container">
            <div className="c-main-nav__wrapper">
              <ul className="c-main-nav">
                <li className="c-main-nav__item submenu">
                  <a 
                    className="parent-link" 
                    href="#!" 
                    onClick={(e) => {
                      e.preventDefault();
                      ToggleKurumsal();
                    }}
                  >
                    Kurumsal
                  </a>
                  {kurumsalisopen && (
                    <ul className="sub-menu" style={{ display: 'block' }}>
                      <li>
                        <Link 
                          to="/tr/kurumsal/mobil-assistance-hakkinda" 
                          onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          Amaç
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/kurumsal/kurumsal-hedefler" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Kurumsal Hedeflerimiz
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/kurumsal/kalite-politikamiz" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Kalite Politikamız
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/kurumsal/kalite-belgelerimiz" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Belgelerimiz
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/kurumsal/tarihcemiz" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Tarihçemiz
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/kurumsal/etik-kurallarimiz" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Etik Kurallarımız
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/kurumsal/kurumsal-kimlik" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Kurumsal Kimlik
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/kurumsal/tanitim-filmi" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Tanıtım Filmi
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li className="c-main-nav__item c-main-nav__item--has-submenu">
                  <a 
                    className="parent-link" 
                    href="#!" 
                    onClick={(e) => {
                      e.preventDefault();
                      ToggleHizmetler();
                    }}
                  >
                    Hizmetlerimiz
                  </a>
                  {hizmetlerisopen && (
                    <ul className="sub-menu" style={{ display: 'block' }}>
                      <li>
                        <Link to="/tr/hizmetlerimiz/yol-yardim-kurtarma-hizmeti" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Yol Yardım Hizmeti
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/hizmetlerimiz/ikame-arac-hizmeti" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          İkame Araç Hizmeti
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/hizmetlerimiz/cagri-merkezi-hizmeti" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Çağrı Merkezi Hizmeti
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/hizmetlerimiz/kisiye-ozel-hizmet-paketleri" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Kişiye Özel Yol Yardım Paketleri
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/hizmetlerimiz/cekici-hizmeti" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Çekici Hizmeti
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/hizmetlerimiz/asistans-altyapi-cozumleri" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Assistance Altyapı Hizmeti
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li className="c-main-nav__item c-main-nav__item--has-submenu">
                  <a 
                    className="parent-link" 
                    href="#!" 
                    onClick={(e) => {
                      e.preventDefault();
                      ToggleOnline();
                    }}
                  >
                    Online İşlemler
                  </a>
                  {onlineisopen && (
                    <ul className="sub-menu" style={{ display: 'block' }}>
                      <li>
                        <a 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          href="https://bayi.mobilassistance.com/Bayi_/Giris"
                          onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}
                        >
                          Bayi Girişi
                        </a>
                      </li>
                      <li>
                        <Link to="/tr/online-islemler/sozlesme-ara" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Sözleşme Ara
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/online-islemler/tedarikci-basvurusu" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Tedarikçi Başvurusu
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/online-islemler/bayi-agimiz" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Bayi Ağımız
                        </Link>
                      </li>
                      <li>
                        <Link to="/tr/online-islemler/bayi-agimiz" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                          Tedarikçi Ağımız
                        </Link>
                      </li>
                    </ul>
                  )}
                </li>
                <li className="c-main-nav__item c-main-nav__item--has-submenu">
                  <Link className="parent-link" to="/tr/mobil-assistance/insan-kaynaklari" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                    İnsan Kaynakları
                  </Link>
                </li>
                <li className="c-main-nav__item c-main-nav__item--has-submenu">
                  <Link className="parent-link" to="/tr/mobil-assistance/iletisim" onClick={() => {
                            setOpen(false);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                          }}>
                    İletişim
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;

